import { JsonPipe } from '@angular/common';
import { Component, OnInit, input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { LinkComponent } from '@teamfoster/sdk/button';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { MenuItem } from '@teamfoster/sdk/menu-ngrx';
import { JsonLdComponent } from 'src/app/seo/components/json-ld/json-ld.component';
import { SocialChannelButtonsComponent } from 'src/app/social-media/components/social-channel-buttons/social-channel-buttons.component';
import { SocialChannel } from 'src/app/social-media/models';
import { SocialIconPipe } from 'src/app/social-media/pipes/social-icon.pipe';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    FromDictionaryPipe,
    JsonLdComponent,
    JsonPipe,
    RouterLink,
    IconComponent,
    SocialChannelButtonsComponent,
    SocialIconPipe,
    LinkComponent,
  ],
})
export class FooterComponent implements OnInit {
  private store = inject(Store);

  private dict = new FromDictionaryPipe();

  domain = input<string>('');
  menu = input<MenuItem[]>([]);
  socials = input<SocialChannel[]>([]);
  memberships = input<SocialChannel[]>([]);
  schema = input<any>({
    '@context': 'http://schema.org',
    '@type': this.dict.transform('overig:footer-json-ld-meta-type'),
    'name': this.dict.transform('overig:meta-titel'),
    'url': this.domain,
    'logo': `${this.domain}/assets/gfx/logo.svg`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'email': this.dict.transform('overig:contact-email'),
      'contactType': 'customer service',
    },
    'sameAs': [],
  });

  year = new Date().getFullYear();

  ngOnInit(): void {
    this.socials().forEach(s => {
      const socialLink = s; // to do config with social buttons
      this.schema().sameAs.push(socialLink);
    });
  }

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }
}
